<template >
    <div class="collabsable-section" id="categories-section">
        <div class="section-title clickable-header" @click="toggleExpanded()">
            <div class="categories-icon"></div>
            <div style="flex-grow: 1;font-size: 17px;">Categories</div>
            <div style="color: gray;"
                :class="['expand-collapse-ico', 'fas', !isExpanded ? 'fa-caret-down' : 'fa-caret-up']">
            </div>
        </div>
        <div v-if="isExpanded" class="expanded-section">
            <div v-if="categories && categories.length > 0" class="table">
                <div class="table-header">
                    <div class="header-item">Name</div>
                    <div class="header-item">Color</div>
                    <div class="header-item"> 
                    </div>
                </div>
                <div class="table-content">
                    <div v-for="category in categories" :key="category.id" class="table-row">
                        <div class="table-data">{{category.name}}</div>
                        <div class="table-data">
                            <div class="category-color" :style="{'background-color':category.color}">
                                <div class="category-color-icon"></div>
                            </div>
                        </div>
                        <div class="table-data table-actions">
                            <button @click="updateCategory(category)" class="fas fa-pen cursor-pointer remove-border action"></button>
                            <button @click="deleteCategory(category)" class="fas fa-trash cursor-pointer remove-border action"></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info-section" style="align-items: center;flex-direction: row;">
                <div class="admin-btn" style="margin-right: 7px;" @click="addCategory()">Add Category</div>
            </div>
        </div>
    </div>
</template>
<script>
import { toggleExpandComponent } from '../../../scripts/js/forgeviewer';
import $ from 'jquery';
export default {
    name: 'AdminCategories',
    emits: ['update_category', 'delete_category'],
    data() {
        return {
            isExpanded: false,
        }
    },
    methods: {
        toggleExpanded() {
            toggleExpandComponent(this);
        },
        addCategory() {
            $('#updateCategoryModal').css('display', 'flex');
        },
        updateCategory(category) {
            this.$emit("update_category", category)
            $('#updateCategoryModal').css('display', 'flex');
        },
        deleteCategory(category) {
            this.$emit("delete_category", category)
        }
    },
    computed: {
        categories() {
            return this.$store.state.categories
        }
    }
}
</script>
<style scoped>
.category-color-icon {
    background-size: cover;
    background-image: url(../../../images/category.png);
    width: 20px;
    height: 20px;
}

.categories-icon {
    background-size: cover;
    background-image: url(../../../images/category-colored.svg);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}

#categories-section {
    font-family: var(--main-font);
    font-weight: 400;
}

#categories-section .admin-btn {
    display: flex;
    align-items: center;
    margin-right: 0px !important;
    width: fit-content;
    padding: 5px 15px;
}

.table {
    width: 100%;
    margin-bottom: 20px;
}

.table .table-header {
    display: flex;
    width: 100%;
    background: var(--light-primary-color);
    font-weight: 600;
    padding: 12px 0;
}

.table .table-row {
    display: flex;
    width: 100%;
    padding: 12px 0;
    margin-left: 0px;
    height: 20px !important;
    border-bottom: 1px solid var(--light-primary-color);
}

.table-row:nth-of-type(odd) {
    background: #f1f1f18a;
}

.table-row:hover {
    background-color: rgba(211, 211, 211, 0.701) !important;
}

.table-data {
    display: flex;
    justify-content: center;
}

.table-data,
.header-item {
    flex: 1 1 20%;
    text-align: center;
}

.category-color {
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
}

.header-item {
    text-transform: uppercase;
    color: #2f2f2f;
}

.table-actions .action {
    color: gray;
    font-size: 20px;



}

.table-actions .fa-trash {
    color: #bc0808;
}

.table-actions .action:hover {
    color: var(--primary-color);
}

.color-picker {
    background: transparent;
    border: none;
}
</style>